import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ContractListContainer from '../../containers/projectmng/ContractListContainer';
import { mapQueryTypeToContractType } from '../../utils/contractType';

// 2026-10-19 메뉴 통합: 프로젝트 관리 + 유지보수 관리 -> 계약 관리(유형 칩, ContractListContainer).
// 옛 /maintancetmng 쪽 리다이렉트(App.js: /projectmng?type=maint)로 들어오면 그 유형을
// 미리 선택해 둔다. 쿼리가 없거나 못 알아보는 값이면 컨테이너가 localStorage에 기억된
// 마지막 선택(또는 기본값 '전체')을 그대로 쓴다.
const ProjectListPage = () => {
  const [searchParams] = useSearchParams();
  const initialContractType = mapQueryTypeToContractType(searchParams.get('type'));

  return <ContractListContainer initialContractType={initialContractType} />;
};

export default ProjectListPage;
